import Component from 'flarum/common/Component';

/**
 * The `Separator` component defines a menu separator item.
 */
class Separator extends Component {
  view() {
    return m("li", {
      className: "separator"
    });
  }
}
Separator.isListItem = true;
export default Separator;
flarum.reg.add('madeyedeer-pallet-theme', 'forum/components/Separator', Separator);